import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip 
} from '@mui/material';
import { tokens } from "../../../theme";
import { useTheme } from '@mui/material/styles';

const DataTable = ({ rows }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <TableContainer 
            component={Paper} 
            sx={{ 
                bgcolor: colors.primary[400], 
                maxHeight: 400 
            }}
        >
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ bgcolor: colors.blueAccent[700], fontWeight: 'bold', color: colors.grey[100] }}>Date</TableCell>
                        <TableCell sx={{ bgcolor: colors.blueAccent[700], fontWeight: 'bold', color: colors.grey[100] }}>User</TableCell>
                        <TableCell sx={{ bgcolor: colors.blueAccent[700], fontWeight: 'bold', color: colors.grey[100] }}>Plan</TableCell>
                        <TableCell sx={{ bgcolor: colors.blueAccent[700], fontWeight: 'bold', color: colors.grey[100] }}>Price</TableCell>
                        <TableCell sx={{ bgcolor: colors.blueAccent[700], fontWeight: 'bold', color: colors.grey[100] }}>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, idx) => (
                        <TableRow 
                            key={idx}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell>{new Date(row.date).toLocaleDateString()} {new Date(row.date).toLocaleTimeString()}</TableCell>
                            <TableCell>{row.user}</TableCell>
                            <TableCell>{row.plan || '-'}</TableCell>
                            <TableCell>${(row.price / 100).toFixed(2)}</TableCell>
                            <TableCell>
                                <Chip 
                                    label={row.status} 
                                    size="small" 
                                    color={row.status === 'started' ? 'success' : 'error'} 
                                    variant="outlined"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DataTable;
